import { useFetchBrowserSession } from './useFetchBrowserSession'

export const useMutateBrowserSession = (() => {
  const authenticate = () => {
    const { authenticate } = useFetchBrowserSession()

    return useAsyncState(authenticate, undefined, { immediate: false })
  }

  const complete = () => {
    const { complete } = useFetchBrowserSession()

    return useAsyncState(complete, undefined, { immediate: false })
  }

  return {
    authenticate,
    complete,
  }
})()
